<p-dialog
  [contentStyle]="{ overflow: 'auto', 'max-height': '60vh', 'min-height': '50vh' }"
  [styleClass]="'sm:col-12 md:col-12 lg:col-7 xl:col-6'"
  [dismissableMask]="false"
  modal="true"
  [(visible)]="visible"
  [closable]="true"
  (onHide)="close($event)"
  appendTo="body"
  >
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{ title }} : {{ dataLabel }}
    </span>
  </ng-template>

  <div class="col-12 md:col-12" style="margin-bottom: 40px">
    <div>
      {{'Queue' | translate}} @if (uploader.queue.length > 0) {
      <span> - {{ uploader.queue.length }} {{'Files' | translate}}</span>
    }
  </div>

  <div class="card text-right">
    <div style="margin: 15px">
      <p-progressBar
        [style]="{ height: '15px', width: '100%' }"
        [value]="uploader.progressTotal" [showValue]="false">
      </p-progressBar>
    </div>
  </div>
  <div class="card" style="margin-top: 20px">
    <table class="table" style="font-size: 14px">
      <thead>
        <tr>
          <th></th>
          <th width="50%">{{'File' | translate}}</th>
          <th>{{'State' | translate}}</th>
          <th>{{'&doc_size' | translate}}</th>
          <th>{{'Work' | translate}}</th>
          <th>{{'Action' | translate}}</th>
        </tr>
      </thead>
      <!-- Mode ajout pj-->
      @if (fileMode === false) {
        <tbody>
          @for (itemFile of uploader.queue; track itemFile; let i = $index) {
            <tr
                [ngClass]="{
                    'table-success': itemFile.isSuccess,
                    'table-danger': itemFile.isError
                }"
              >
              <!-- Affichage vignette mode pj -->
              <td [ngxThumbnail]="itemFile"></td>
              <!-- Affichage nom fichier mode pj -->
              <td>{{ itemFile.file.name }}</td>
              <!-- Saisie index -->
              <td></td>
              <!-- Taille-->
              <td style="text-align: center">{{ itemFile.file.size / 1024 / 1024 | number: '1.0-2' }} MB</td>
              <!-- Progress bar -->
              <td>
                <div>
                  <p-progressBar
                    [style]="{ height: '15px', width: '100%' }"
                    [value]="itemFile.progress" [showValue]="false">
                  </p-progressBar>
                </div>
              </td>
              <!-- Stop -->
              @if (!displayStopValue) {
                <td style="text-align: center">
                  <i
                    class="icons8-trash-can margin-right iconstyle"
                    (click)="removeItem(itemFile)"
                    style="color: red"
                  ></i>
                </td>
              }
            </tr>
          }
        </tbody>
      }
      @else {
        <!-- Mode ajout fichier-->
        <tbody>
          @for (itemFile of uploader.queue; track itemFile; let i = $index) {
            <tr
                [ngClass]="{
                'table-success': itemFile.isSuccess,
                'table-danger': itemFile.isError
                }"
              >
              @if (bskType === 'btMail' || enterVariable === true) {
                <!-- Affichage vignette mode index -->
                <td class="word-break-all cursorPointer"
                  (click)="setIndex(bskDocAddList[i], i)"
                  [ngxThumbnail]="itemFile"
                  >
                </td>
                <!-- Affichage nom fichier mode index -->
                <td
                    [ngClass]="{
                        'blue': ctrlDouble[i].change === true
                    }"
                    class="word-break-all cursorPointer"
                    (click)="setIndex(bskDocAddList[i], i)"
                  >
                  {{ itemFile.file.name }}
                </td>
                <td style="text-align: center">
                  <span
                  class="word-break-all cursorPointer"
                  (click)="setIndex(bskDocAddList[i], i)"
                  >
                  @if (bskDocAddList[i].saveIndex === false) {
                      @if (bskType === 'btMail') {
                        <i
                          class="pi pi-pencil margin-left"
                          style="color: orange"
                          pTooltip="{{'Ent_Idx' | translate}}"
                          tooltipPosition="top"
                        ></i>
                      }
                      @else {
                          @if (requiredVariable === true) {
                            <i
                              class="pi pi-pencil margin-left"
                              pTooltip="{{'Ent_IdxReq' | translate}}"
                              tooltipPosition="top"
                              style="color: orange"
                            ></i>
                          }
                          @else {
                            <i
                              pTooltip="{{'Ent_IdxNo' | translate}}"
                              tooltipPosition="top"
                              class="pi pi-pencil margin-left"
                              style="color: grey"
                            ></i>
                          }
                      }
                  }
                  @if (bskDocAddList[i].saveIndex === true) {
                    <i
                      pTooltip="{{'Add_Done' | translate}}"
                      tooltipPosition="top"
                      class="pi pi-check margin-left"
                      style="color: green"
                    ></i>
                  }
                </span>
                </td>
              }
              @if (enterVariable === false) {
                <td class="word-break-all"
                  [ngxThumbnail]="itemFile">
                </td>
                <td>{{ itemFile.file.name }}</td>
                <td style="text-align: center"></td>
              }
              <!-- Taille-->
              <td style="text-align: center">{{ itemFile.file.size / 1024 / 1024 | number: '1.0-2' }} MB</td>
              <!-- Progress bar -->
              <td>
                <div>
                  <p-progressBar
                    [style]="{ height: '15px', width: '100%' }"
                    [value]="itemFile.progress" [showValue]="false">
                  </p-progressBar>
                </div>
              </td>
              <!-- Stop -->
              @if (!displayStopValue) {
                <td style="text-align: center">
                  <i
                    class="icons8-trash-can margin-right iconstyle"
                    (click)="removeItem(itemFile)"
                    style="color: red"
                  ></i>
                </td>
              }
            </tr>
          }
        </tbody>
      }
    </table>
  </div>
</div>
<ng-template pTemplate="footer">
  <div class="grid">
    <div class="col-12 md:col-10 lg:col-10">
      @if (!displayStopValue) {
        <div class="drag-container" (click)="$event.stopPropagation()">
          <div class="my-drop-zone" [ngxDragAndDrop]="options" *ngxInputFile>
            <div class="drag-text">
              {{'File_Add' | translate}}
            </div>
          </div>
        </div>
      }
    </div>
    <div class="col-12 md:col-2 lg:col-2">
      @if (!displayStopValue) {
        <button
          class="margin"
          pButton
          type="button"
          [disabled]="disabledSend"
          (click)="clickAdd($event)"
          label="{{'Valid' | translate}}"
        ></button>
      }
      @else {
        <button
          class="margin"
          style="background-color: red; color: white"
          pButton
          type="button"
          (click)="clickStop($event)"
          label="{{'Stop' | translate}}"
        ></button>
      }
    </div>
  </div>
</ng-template>
</p-dialog>
